export default {
	onBurgerClick() {
		this.$store.dispatch("toggleBurger");
	},
};
